import { Component, OnInit, Input, Output, EventEmitter, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FormBuilder } from '@angular/forms';
import { HttpHelpUtils } from './../../utils/HttpHelpUtils';
import { BaseCommpont } from 'src/app/utils/BaseCommpont';
import { MessageSub } from './../../utils/MessageSub';
import { RadioButtonModule } from 'primeng/radiobutton';
import { SelectButtonModule } from 'primeng/selectbutton';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { ButtonModule } from 'primeng/button';
import { PDetailSidebarModule } from './../../components/p-detail-sidebar/p-detail-sidebar.component';
import { TruckDetailModule } from './../../components/truck-detail/truck-detail.component';
import { ImagePreviewService } from './../../components/image-viewer/image-preview.service';
import { SkeletonModule } from 'primeng/skeleton';
import { AccordionModule } from 'primeng/accordion';
import { ChipModule } from 'primeng/chip';
import { DomSanitizer } from '@angular/platform-browser';
import { ChartModule } from 'primeng/chart';
import { KnobModule } from 'primeng/knob';
import { TooltipModule } from 'primeng/tooltip';
import {DialogModule} from 'primeng/dialog';
import { RegExUtils } from '../../utils/RegExUtils';

@Component({
    selector: 'app-driver-detail',
    templateUrl: './driver-detail.component.html',
    styleUrls: ['./driver-detail.component.scss']
})
export class DriverDetailComponent implements OnInit {
    credentials: string;                                                    // radiobutton:ngmodel
    stateOptions = []                                                       // selectButton
    value1: string = "off";                                                   // selectButton value1 status
    regExUtils = new RegExUtils();                                  // 校验规则
    driverId = '';
    truckList = [];
    bankList = [];
    @Input() driverDetail: {} = {};                                             // 运单输入详情
    @Output() onClose: EventEmitter<any> = new EventEmitter();                  // 关闭弹窗
    @Input() percentWidth = 80;                                                 // 宽度比例，默认是80%；
    localDriverDetail = {};                                                    // 运单详情
    bc = new BaseCommpont();

    idCardNoBack = '';
    idCardNoFront = '';
    drivingLicense = '';
    drivingLicenseBack = '';
    driverTypeMap = {};
    politicalOutlookMap = {};//政治面貌
    qualificationCertIssueArea = '';//从业资格证颁发机构所在地（省市）
    driverWaybillNum = 0;//运单量
    driverWayibllMoneyYear = 0;
    driverWayibllMoneyTotal = 0;

    driverWayibllPayMoney = 0;
    todayWaybillNum = 0;
    monthWaybillNum = 0;
    monthWaybillPayMoney = 0;
    monthWaybillMoney = 0;
    relTruckList = [];//车辆数据
    bankAccountList = [];//银行卡数据
    relAgentList = [];//代理商
    relCusList = [];//关联货主
    relAgentorList = [];//关联车队长
    vehicleTypeMap = {};//车辆类型
    areaList = [];//常跑路线
    driverCumulativeType = 3;
    driverMonthLimitAmount = 0;//每月限额
    driverYearLimitAmount = 0;//每年限额
    warningFlag = false;//超额图标开启标志
    warningTitle = '本年承运费';
    driverWayibllMoney = 0;
    //加载项
    loadingDriverInfo = false;
    loadingRelInfo = false;

    endDateColor = '#4ea844';
    goodsType: any;
    goodsTypeOptions: any;
    driverEvaluate = 0;

    sex = {
        1: '男',
        0: '女'
    };
    useStatus = {                                                     // 使用状态
        0: '空闲',
        1: '工作中'
    };
    checkFlag = {                                                     // 审核状态
        0: "待提交",
        1: "待审核",
        2: "已审核",
        3: "审核不过"
    };
    //来源（0：系统录入，1：数据导入，2：小程序，3：app）
    source = {
        0:'系统录入',
        1:'EXECL导入',
        2:'微信小程序',
        3:'司机端APP'
    }
    //签署状态,0:待签署，1：签署中，2：签署完成，3：签署失败
    signStatus = {
        0:'待签署',
        1:'签署中',
        2:'已签署',
        3:'签署失败'
    }

    constructor(
        private httpHelp: HttpHelpUtils,
        private fb: FormBuilder,
        private imagePreviewService: ImagePreviewService,
        private messageSub: MessageSub,
        private sanitizer : DomSanitizer
    ) {
        this.stateOptions = [{ label: '未通过', value: 'off' }, { label: '通过', value: 'on' }];
    }

    //关闭
    closeDetail() {
        this.onClose.emit();
    }

    //详情图表新增开始
    imgDescribe = '';
    // 切换tab
    tabList = ["用户数据", "影像资料"]
    imgPriview: '';                                                               // 展示图
    thumbnailImageSrc = [];                                                       // 缩略图
    current = 0;                                                                  // 旋转角度
    chartData: any;                                                               // 柱状图数据
    chartOptions: any;
    // 向左旋转
    handleTurnLeft() {
        let img = <HTMLImageElement>document.querySelector('.img-preview')
        this.current = (this.current - 90) % 360;
        img.style.transform = 'rotate(' + this.current + 'deg)'
    }
    // 向右旋转
    handleTurnright() {
        let img = <HTMLImageElement>document.querySelector('.img-preview')
        this.current = (this.current + 90) % 360;
        img.style.transform = 'rotate(' + this.current + 'deg)'
    }
    // 预览图切换
    previewImgIndex = 0                                                                           // 小图下标
    afiles = [];
    handlePreviewImgClick(item, i) {
        this.imgPriview = item.url;
        this.imgDescribe = item.title;
        this.previewImgIndex = i;
        this.current = 0
        this.afiles.push(this.imgPriview)
    }
    // 切换tab
    activeIndex = 0;
    handleTabClick(i) {
        this.activeIndex = i;
    }

    showTruckDetailDialog = false;
    truckDetail = {};
    showTruckDetail(item) {
        this.truckDetail = {
            truckId: item.truckId
        }
        this.showTruckDetailDialog = true;
    }

    // 预览图片接口
    async viewOSSFile(folder, imgName) {
        const that = this;
        let result = {};
        return new Promise((resolve, reject) => {
            that.httpHelp.get('psg/common/view-img', {
                folder: folder,
                imgName: imgName,
                vehicleType: 2
            }).then(res => {
                resolve(res);
            }).catch(err => {
                reject(err);
            });
        });
    }

    //初始化代码表字典
    dicInit() {
        this.httpHelp.get('psg/diction/dicType', {
            dicTypes: 'driving_license,political_outlook,vehicle_classification_code'
        }).then(res => {
            if (res['status'] == 'success') {
                const tempGoodsTypeList = res['data'];
                tempGoodsTypeList.forEach(e => {
                    if (e['dicType'] == 'driving_license') {
                        this.driverTypeMap[e['value']] = e['text'];
                    } else if (e['dicType'] == 'political_outlook') {
                        //政治面貌
                        this.politicalOutlookMap[e['value']] = e['text'];
                    } else if (e['dicType'] == 'vehicle_classification_code') {
                        this.vehicleTypeMap[e['value']] = e['text'];
                    }
                });
            } else {
                this.bc.showMessage(this.messageSub, res['message'], 'error');
            }
        });
    }

    //初始化
    ngOnInit(): void {
        this.dicInit();
        this.chartOptions = {
            // title: {
            //     display: true,
            //     text: '运单数据',
            //     fontSize: 16
            // },
            legend: {
                position: 'top'
            }, scales: {
                yAxes: [{
                    ticks: {
                        beginAtZero: true
                    }
                }]
            },
            responsive: true
        };
        this.goodsTypeOptions = {
            responsive: true,
            legend: {
                position: 'right'
            }
        }
        //加载司机基础数据
        this.localDriverDetail = {};
        this.loadingDriverInfo = true;
        this.httpHelp.get('psg/drivers/get-driver-detail', { driverId: this.driverDetail['driverId'] }).then(res => {
            this.loadingDriverInfo = false;
            if (res['status'] == this.bc.svrType) {
                if (res['data']) {
                    this.localDriverDetail = res['data'];
                    this.localDriverDetail['expiredWarnDay'] = this.driverDetail['expiredWarnDay'];
                    
                    // 获取从业资格证颁发机构所在地（省市）
                    if (this.localDriverDetail['qualificationCertIssueAreaCode']) {
                        this.getQualificationCertIssueArea(this.localDriverDetail['qualificationCertIssueAreaCode']);
                    } else {
                        this.qualificationCertIssueArea = '暂无';
                    }
                    
                    if(res['data']['drivingStartUseDate']<0){
                        this.localDriverDetail['drivingStartUseDate'] = ''
                    }
                    if(res['data']['drivingEndUseDate']<0){
                        this.localDriverDetail['drivingEndUseDate'] = ''
                    }
                    // 身份证正面
                    if (this.localDriverDetail['idCardNoFront']) {
                        this.viewOSSFile('idcard', this.localDriverDetail['idCardNoFront']).then(res1 => {
                            this.idCardNoFront = res1['data']['url'];
                            let obj = { 'url': this.idCardNoFront, 'title': '身份证正面' };
                            this.thumbnailImageSrc.push(obj);
                            if (this.thumbnailImageSrc.length > 0) {
                                this.imgDescribe = this.thumbnailImageSrc[0]['title'];
                            }
                        })
                    }
                    // 身份证正面
                    if (this.localDriverDetail['idCardNoBack']) {
                        this.viewOSSFile('idcard', this.localDriverDetail['idCardNoBack']).then(res2 => {
                            this.idCardNoBack = res2['data']['url'];
                            let obj = { 'url': this.idCardNoBack, 'title': '身份证反面' };
                            this.thumbnailImageSrc.push(obj);
                            if (this.thumbnailImageSrc.length > 0) {
                                this.imgDescribe = this.thumbnailImageSrc[0]['title'];
                            }
                        })
                    }
                    //驾驶证主页
                    if (this.localDriverDetail['drivingLicensePhoto']) {
                        this.viewOSSFile('idcard', this.localDriverDetail['drivingLicensePhoto']).then(res3 => {
                            this.drivingLicense = res3['data']['url'];
                            let obj = { 'url': this.drivingLicense, 'title': '驾驶证正面' };
                            this.thumbnailImageSrc.push(obj);
                            if (this.thumbnailImageSrc.length > 0) {
                                this.imgDescribe = this.thumbnailImageSrc[0]['title'];
                            }
                        })
                    }
                    //驾驶证副页 - 如果后端返回则使用后端图片，否则使用占位图
                    const drivingLicenseBackPhotoPlaceholder = 'assets/file/image/jsz_fyb.png';
                    if (this.localDriverDetail['drivingLicenseBackPhoto']) {
                        this.viewOSSFile('idcard', this.localDriverDetail['drivingLicenseBackPhoto']).then(res4 => {
                            this.drivingLicenseBack = res4['data']['url'];
                            let obj = { 'url': this.drivingLicenseBack, 'title': '驾驶证副页' };
                            this.thumbnailImageSrc.push(obj);
                            if (this.thumbnailImageSrc.length > 0) {
                                this.imgDescribe = this.thumbnailImageSrc[0]['title'];
                            }
                        })
                    } else {
                        // 如果后端没有返回驾驶证副页，使用占位图片
                        this.drivingLicenseBack = drivingLicenseBackPhotoPlaceholder;
                        let obj = { 'url': this.drivingLicenseBack, 'title': '驾驶证副页' };
                        this.thumbnailImageSrc.push(obj);
                        if (this.thumbnailImageSrc.length > 0) {
                            this.imgDescribe = this.thumbnailImageSrc[0]['title'];
                        }
                    }
                    //从业资格证
                    if (this.localDriverDetail['qualificationCertPhoto']) {
                        this.viewOSSFile('idcard', this.localDriverDetail['qualificationCertPhoto']).then(res5 => {
                            this.drivingLicense = res5['data']['url'];
                            let obj = { 'url': this.drivingLicense, 'title': '从业资格证' };
                            this.thumbnailImageSrc.push(obj);
                            if (this.thumbnailImageSrc.length > 0) {
                                this.imgDescribe = this.thumbnailImageSrc[0]['title'];
                            }
                        })
                    }
                }
            } else {
                this.bc.showMessage(this.messageSub, '加载基础数据异常：' + res['message'], 'error');
            }
        });
        //加载车辆、代理商、货主、车队长银行卡数据
        this.relTruckList = [];
        this.bankAccountList = [];
        this.relAgentorList = [];
        this.loadingRelInfo = true;
        this.httpHelp.get('psg/drivers/get-driver-rel-detail', { driverId: this.driverDetail['driverId'] }).then(res => {
            this.loadingRelInfo = false;
            if (res['status'] == this.bc.svrType) {
                if (res['data']) {
                    this.relTruckList = res['data']['relTruckList'];//关联车辆
                    this.bankAccountList = res['data']['bankAccountList'];//关联银行卡
                    this.relAgentorList = res['data']['relAgentorList'];//关联车队长
                    //加载代理商
                    // if (res['data']['relAgentList'].length > 0) {
                    //     let agentIds = '';
                    //     let relAgentListTmp = res['data']['relAgentList'];
                    //     relAgentListTmp.forEach(item => {
                    //         agentIds += item.agentId + ',';
                    //     });
                    //     this.httpHelp.get('sys/agent/query-rel-agent', { ids: agentIds }).then(res => {
                    //         if (res['status'] == 'success') {
                    //             this.relAgentList = res['data'];//关联代理商信息
                    //         } else {
                    //         }
                    //     });
                    // }
                    // //关联货主信息
                    // if (res['data']['relCusList'].length > 0) {
                    //     let custIds = '';
                    //     let relCusListTmp = res['data']['relCusList'];
                    //     relCusListTmp.forEach(item => {
                    //         custIds += item.shipperId + ',';
                    //     });
                    //     //加载货主
                    //     this.httpHelp.get('sys/cust/query-rel-cust', { ids: custIds }).then(res => {
                    //         if (res['status'] == 'success') {
                    //             this.relCusList = res['data'];
                    //         } else {
                    //         }
                    //     });
                    // }
                }
            } else {
                this.bc.showMessage(this.messageSub, '加载关联数据异常：' + res['message'], 'error');
            }
        });
        //加载合计数据
        this.httpHelp.get('psg/drivers/get-driver-total', { driverId: this.driverDetail['driverId'] }).then(res => {
            if (res['status'] == this.bc.svrType) {
                if (res['data']) {
                    //图表数据
                    let labels = [], money = [], number = [];
                    const monthData: [] = res['data']['monthTotalList'];
                    for (let i = 11; i >= 0; i--) {
                        const tempMonth = this.bc.setCreateTime(new Date().getTime() - (i * 720 * 3600 * 1000), 'yyyy-MM');
                        labels.push(tempMonth);
                        if (monthData && monthData.length > 0) {
                            let tempMoney = 0, tempNumber = 0;
                            a: for (var y = 0; y < monthData.length; y++) {
                                if (monthData[y]['dateMonth'] == tempMonth) {
                                    tempMoney = monthData[y]['totalMoney'];
                                    tempNumber = monthData[y]['totalNumber'];
                                    break a;
                                }
                            }
                            money.push(tempMoney);
                            number.push(tempNumber);
                        } else {
                            money.push(0);
                            number.push(0);
                        }
                    }
                    //图表加载
                    this.chartData = {
                        labels: labels,
                        datasets: [{
                            type: 'line',
                            label: '承运费',
                            borderColor: '#42A5F5',
                            borderWidth: 2,
                            fill: false,
                            data: money
                        }, {
                            type: 'bar',
                            label: '运单量',
                            backgroundColor: '#dca451',
                            data: number
                        }],
                        scales: {
                            yAxes: [{
                                ticks: {
                                    beginAtZero: true
                                }
                            }]
                        }
                    };
                    this.driverWaybillNum = res['data']['totalNumber'];//承运订单量
                    this.driverWayibllMoneyTotal = res['data']['totalMoney'];//累计承运费
                    //this.driverWayibllMoneyYear = res['data']['totalMoneyYear'];//本年承运费
                    //本月数据
                    this.monthWaybillNum = res['data']['monthMoney'];
                    this.monthWaybillMoney = res['data']['monthNumber'];
                    if(res['data']['shipperSet']){
                        let shipperSet = res['data']['shipperSet'];
                        this.driverCumulativeType = shipperSet['driver_cumulative_type'];//司机每月/年限额累加方式，1：按月，2：按年，3：不限制
                        this.driverMonthLimitAmount = shipperSet['driver_month_limit_amount'];//每月限额
                        this.driverYearLimitAmount = shipperSet['driver_year_limit_amount'];//每年限额
                        if(this.driverCumulativeType==1){
                            this.warningTitle = '本月承运费';
                            this.driverWayibllMoney = res['data']['monthMoney'];
                            if(this.driverMonthLimitAmount>0){
                                if(this.driverMonthLimitAmount<this.driverWayibllMoney){
                                    this.warningFlag = true;
                                }
                            }
                        }else if(this.driverCumulativeType==2){
                            this.warningTitle = '本年承运费(元)';
                            this.driverWayibllMoney = res['data']['totalMoneyYear'];
                            if(this.driverYearLimitAmount>0){
                                if(this.driverYearLimitAmount<this.driverWayibllMoney){
                                    this.warningFlag = true;
                                }
                            }
                        }else {
                            this.warningFlag = false;
                            this.warningTitle = '本年承运费(元)';
                            this.driverWayibllMoney = res['data']['totalMoneyYear'];
                        }
                    }else {
                        this.warningFlag = false;
                        this.warningTitle = '本年承运费(元)';
                        this.driverWayibllMoney = res['data']['totalMoneyYear'];
                    }
                }
            } else {
                this.bc.showMessage(this.messageSub, '加载用户数据异常：' + res['message'], 'error');
            }
        });
        //加载合计数据
        this.httpHelp.get('psg/drivers/get-driver-area', { driverId: this.driverDetail['driverId'] }).then(res => {
            if (res['status'] == this.bc.svrType) {
                if (res['data']) {
                    //常跑路线
                    this.areaList = res['data']['driverAreaList'];
                    //运输货物类型占比
                    const goodsData: [] = res['data']['waybillGoodsData'];
                    const waybillGoodsData = [], waybillGoodsLabels = [];
                    if (goodsData && goodsData.length > 0) {
                        for (let i in goodsData) {
                            waybillGoodsData.push(goodsData[i]['goodsNum']);
                            waybillGoodsLabels.push(goodsData[i]['goodsName']);
                        }
                    }
                    this.goodsType = {
                        datasets: [{
                            data: waybillGoodsData,
                            backgroundColor: [
                                "#5760e5",
                                "#289934",
                                "#43b4c2",
                                "#e88689",
                                "#f49627",
                                "#666e85",
                                "#E7E9ED"
                            ],
                            label: '运输货物类型占比'
                        }],
                        labels: waybillGoodsLabels
                    }
                }
            } else {
                this.bc.showMessage(this.messageSub, '加载数据异常：' + res['message'], 'error');
            }
        });
    }

    //查看法大大协议
    showFadadaDriverFlag = false;//弹框开关
    agreeHeaderTitle = '';//标题
    safeUrl;//协议链接地址
    
    // 根据市级区域代码获取从业资格证颁发机构所在地（省+市）
    async getQualificationCertIssueArea(cityCode: string) {
        if (!cityCode) {
            this.qualificationCertIssueArea = '暂无';
            return;
        }
        
        try {
            // 先获取所有省份列表
            const provinceRes: any = await this.httpHelp.get('psgsys/sj/areainfo/getAreaList?pAreaCode=0&provinceName=', {});
            
            if (provinceRes['code'] === 0 && provinceRes['data']) {
                const provinces = provinceRes['data'];
                
                // 遍历每个省份，查找包含该城市代码的省份
                for (const province of provinces) {
                    const cityRes: any = await this.httpHelp.get('psgsys/sj/areainfo/getAreaList?pAreaCode=' + province['areaCode'] + '&provinceName=', {});
                    
                    if (cityRes['code'] === 0 && cityRes['data']) {
                        const cities = cityRes['data'];
                        
                        // 尝试字符串和数字两种比较方式
                        const city = cities.find(c => {
                            return String(c['areaCode']) === String(cityCode) || c['areaCode'] == cityCode;
                        });
                        
                        if (city) {
                            // 找到了，组合省+市
                            this.qualificationCertIssueArea = province['areaName'] + city['areaName'];
                            return; // 找到后直接返回
                        }
                    }
                }
                
                // 如果遍历完所有省份都没找到
                this.qualificationCertIssueArea = '暂无';
            } else {
                this.qualificationCertIssueArea = '暂无';
            }
        } catch (err) {
            console.error('获取从业资格证颁发机构所在地失败:', err);
            this.qualificationCertIssueArea = '暂无';
        }
    }
    
    showFadadaDriverAgree(res){
        if (res['contractNo']) {
            this.agreeHeaderTitle = '委托代开协议（' + res['realname'] + '）';
            this.httpHelp.loadingBlock = true;
            this.httpHelp.get('psg/drivers/get-driver-fadada', { contractNo: res['contractNo'] }).then(res => {
                this.httpHelp.loadingBlock = false;
                if (res['status'] == this.bc.svrType && res['data']) {
                    this.safeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(res['data']['signUrl']);
                    this.showFadadaDriverFlag = true;
                } else {
                    this.bc.showMessage(this.messageSub, '获取法大大协议失败：' + res['message'], 'error');
                }
            });
        }
    }

    // 预览右侧缩略图
    previewThumbnailImage() {
        var img = document.querySelector('.img-preview-img').getAttribute("src")
        let show_photo_list = [];
        let index = 0;
        for(var i=0;i<this.thumbnailImageSrc.length;i++){
            let e =this.thumbnailImageSrc[i];
            if (e['url']==img) {
                index = i;
            }
            show_photo_list.push(e['url']);
        }
        this.imagePreviewService.preview(show_photo_list,index);
    }

    // 查看司机人车照
    checkDriverTruckPhoto(data) {
        this.viewOSSFile(this.regExUtils.TRUCK, data['driverTruckPhoto']).then(res => {
            if (res['status'] == this.bc.svrType) {
                this.imagePreviewService.preview([
                    res['data']['url']
                ]);
            } else {
                this.bc.showMessage(this.messageSub, res['message'], 'error');
            }
        });
    }

    //查看代收协议
    checkAgentAgreePhoto(res) {
        this.viewOSSFile(this.regExUtils.ID_CARD, res['agentAgree']).then(res => {
            if (res['status'] == this.bc.svrType) {
                this.imagePreviewService.preview([
                    res['data']['url']
                ]);
            } else {
                this.bc.showMessage(this.messageSub, res['message'], 'error');
            }
        });
    }
}

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        SelectButtonModule,
        PDetailSidebarModule,
        RadioButtonModule,
        ButtonModule,
        InputTextareaModule,
        TruckDetailModule,
        SkeletonModule,
        ChartModule,
        KnobModule,
        AccordionModule,
        ChipModule,
        TooltipModule,
        DialogModule
    ],
    exports: [DriverDetailComponent],
    declarations: [DriverDetailComponent]
})
export class DriverDetailModule { }
